import { useSyncExternalStore } from 'react';
import { authService } from '@/services/auth/authService';

/**
 * ABP feature gating for whole modules.
 *
 * Every backend module defines an "{Module}.Enable" feature (e.g.
 * "Pricing.Enable"). When it evaluates to "false" for the current
 * tenant, the backend rejects all of the module's endpoints — so the
 * frontend hides the module's menu entries and search commands.
 */

/** Feature key gating a module's whole UI surface. */
export function moduleEnableFeature(module: string): string {
  return `${module}.Enable`;
}

/**
 * Check a feature against the cached feature values. A feature counts as
 * enabled unless the configuration explicitly says "false" — modules
 * without an Enable feature (and the brief window before the
 * application-configuration has loaded) stay visible.
 */
export function isFeatureEnabled(
  featureValues: Record<string, string>,
  feature?: string,
): boolean {
  if (!feature) return true;
  return featureValues[feature]?.toLowerCase() !== 'false';
}

const featuresSubscribe = (cb: () => void) => authService.subscribePermissions(cb);
const featuresSnapshot = () => authService.getFeatureValues();

/** Subscribe to the cached ABP feature values (same fetch as permissions). */
export function useFeatureValues(): Record<string, string> {
  return useSyncExternalStore(featuresSubscribe, featuresSnapshot);
}
